import React, { useEffect, useState } from 'react';
import styles from './eventOptions.module.scss';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Drawer, Modal, Typography } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import stylesModal from '../Profile/Customize/customize.module.scss';
import { isMobile } from 'react-device-detect';
import fetchData from '../../fetch';

const mapStateToProps = (state) => {
    return {
        isAdmin: state.user.currentUser.groups && state.user.currentUser.groups.includes('Admin'),
        company: state.common.company
    };
};

function EventOptions(props) {
    const { t } = useTranslation();
    const REDIRECT_URL = 'https://redirect.bajenidag.app/redirect/bajenidag/events/'; //HARDCODED?
    const isClicked = props.isClicked;
    const isMessage = props.isMessage;
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const click = (currentEvent) => {
        var options = {
            message: t('ComeAndWatch') + ' ' + currentEvent.title,
            subject: t('ComeAndWatch') + ' ' + currentEvent.title, //email
            files: ['', ''], // an array of filenames either locally or remotely
            url: `${REDIRECT_URL}${currentEvent.slug}`
        };
        window.plugins.socialsharing.shareWithOptions(options);
    };

    const [isReminderVisible, setIsReminderVisible] = useState(false);

    const deleteEvent = async (id) => {
        setLoading(true);
        await fetchData.Event.DeleteEvent(id);
        setLoading(false);
        setOpenModal(false);
        props.setIsClicked(false);
        if (props.setVideoDeleted) {
            props.setVideoDeleted((prev) => !prev);
        }
    };

    useEffect(() => {
        if (!isMessage) {
            var endTime = new Date(props.event.end_date);
            var now = new Date();
            if (endTime > now) {
                setIsReminderVisible(true);
            } else {
                setIsReminderVisible(false);
            }
        }
    }, []);

    const setReminderInCalendar = (currentEvent) => {
        var title = currentEvent.title;
        var eventLocation = '';
        var notes = '';
        var startDate = new Date(currentEvent.start_date);
        var endDate = new Date(currentEvent.end_date);

        window.plugins.calendar.createCalendar('Calendar');
        var calOptions = window.plugins.calendar.getCalendarOptions(); // grab the defaults
        calOptions.firstReminderMinutes = 15; // default is 60
        calOptions.secondReminderMinutes = 0;
        calOptions.url = `${REDIRECT_URL}${currentEvent.slug}`;
        calOptions.calendarId = 1;

        if (window.device.platform === 'iOS') {
            window.plugins.calendar.findEvent(
                currentEvent.title,
                null,
                null,
                new Date(currentEvent.start_date),
                new Date(currentEvent.end_date),
                function (message) {
                    if (message && !message.length) {
                        window.plugins.calendar.createEventWithOptions(
                            title,
                            eventLocation,
                            notes,
                            startDate,
                            endDate,
                            calOptions
                        );
                        props.notify('Event added to calendar');
                    } else {
                        props.notify('Event already exists');
                    }
                },
                function (message) {
                    console.log('Error: ' + message);
                }
            );
        } else {
            window.plugins.calendar.createEventWithOptions(
                title,
                eventLocation,
                notes,
                startDate,
                endDate,
                calOptions
            );
            props.notify('Event added to calendar');
        }
    };

    const checkPermissions = (currentEvent) => {
        if (window.device.platform === 'Android') {
            const { permissions } = window.cordova.plugins;

            var list = [permissions.READ_CALENDAR, permissions.WRITE_CALENDAR];

            permissions.hasPermission(
                list,
                function (status) {
                    if (status.hasPermission) {
                        setReminderInCalendar(currentEvent);
                    } else {
                        permissions.requestPermissions(
                            list,
                            function (status) {
                                if (status.hasPermission) {
                                    setReminderInCalendar(currentEvent);
                                }
                            },
                            function (error) {
                                console.error(error);
                            }
                        );
                    }
                },
                function (error) {
                    console.error(error);
                }
            );
        } else {
            setReminderInCalendar(currentEvent);
        }
    };

    return (
        <>
            {/* {props.message && isClicked && isMessage && (
                <div className={`${styles.messageLine} ${styles.unselectable}`}>
                    {props.message && props.message.avatar ? (
                        <img
                            src={props.message.avatar}
                            alt={t('Avatar')}
                            className={styles.unselectable}
                        />
                    ) : (
                        <div className={`${styles.profilePictureGenerated} ${styles.unselectable}`}>
                            {props.initials}
                        </div>
                    )}
                    <aside>
                        <span className={styles.unselectable}>{props.message.nickname}</span>
                        <p className={styles.unselectable}>{props.message.message} </p>{' '}
                    </aside>
                </div>
            )} */}
            <Drawer anchor="bottom" open={isClicked} onClose={() => props.setIsClicked(false)}>
                {/* {isClicked && ( */}
                <div onClick={() => props.setIsClicked(false)} className={styles.wrapperOverlay}>
                    <div className={styles.eventOptions}>
                        {window.cordova && (
                            <button
                                className={styles.eventOptionItem}
                                onClick={() => click(props.event)}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M23.625 10.9375L23.6241 4.37587L17.0625 4.375"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M15.7468 12.2532L23.6218 4.37817"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M19.75 15.875V22.875C19.75 23.1071 19.6578 23.3296 19.4937 23.4937C19.3296 23.6578 19.1071 23.75 18.875 23.75H4.875C4.64294 23.75 4.42038 23.6578 4.25628 23.4937C4.09219 23.3296 4 23.1071 4 22.875V8.875C4 8.64294 4.09219 8.42038 4.25628 8.25628C4.42038 8.09219 4.64294 8 4.875 8H11.875"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span>{t('ShareTo')}</span>
                            </button>
                        )}
                        {/* {isReminderVisible && (
                            <button
                                className={styles.eventOptionItem}
                                onClick={() => checkPermissions(props.event)}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M22.75 4.375H5.25C4.76675 4.375 4.375 4.76675 4.375 5.25V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V5.25C23.625 4.76675 23.2332 4.375 22.75 4.375Z"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M19.25 2.625V6.125"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M8.75 2.625V6.125"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M4.375 9.625H23.625"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M16.625 14L11.375 19.25"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M16.625 19.25L11.375 14"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span>{t('CreateMemory')}</span>
                            </button>
                        )} */}
                        <Link to={`/report/${props.event.id}`}>
                            <button className={styles.eventOptionItem}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.3701 21.4247L14.7503 24.1244C14.6725 24.2539 14.5626 24.3612 14.4311 24.4356C14.2996 24.5101 14.1511 24.5492 14 24.5492C13.8489 24.5492 13.7003 24.5101 13.5688 24.4356C13.4374 24.3612 13.3274 24.2539 13.2497 24.1244L11.6299 21.4247C11.5521 21.2951 11.4422 21.1879 11.3107 21.1135C11.1792 21.039 11.0307 20.9999 10.8796 20.9999H4.375C4.14293 20.9999 3.92037 20.9077 3.75628 20.7436C3.59219 20.5795 3.5 20.357 3.5 20.1249V6.125C3.5 5.89293 3.59219 5.67037 3.75628 5.50628C3.92037 5.34219 4.14293 5.25 4.375 5.25H23.6249C23.857 5.25 24.0795 5.34219 24.2436 5.50628C24.4077 5.67037 24.4999 5.89293 24.4999 6.125V20.1249C24.4999 20.2399 24.4773 20.3536 24.4333 20.4598C24.3893 20.566 24.3249 20.6624 24.2436 20.7437C24.1624 20.8249 24.0659 20.8894 23.9598 20.9333C23.8536 20.9773 23.7398 20.9999 23.6249 20.9999L17.1204 20.9999C16.9693 20.9999 16.8207 21.039 16.6893 21.1135C16.5578 21.1879 16.4478 21.2951 16.3701 21.4247Z"
                                        stroke={'black'}
                                        strokeWidth="1.74999"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M14 14.4375C14.7249 14.4375 15.3125 13.8499 15.3125 13.125C15.3125 12.4001 14.7249 11.8125 14 11.8125C13.2751 11.8125 12.6875 12.4001 12.6875 13.125C12.6875 13.8499 13.2751 14.4375 14 14.4375Z"
                                        fill={'black'}
                                    />
                                    <path
                                        d="M8.74999 14.4375C9.47487 14.4375 10.0625 13.8499 10.0625 13.125C10.0625 12.4001 9.47487 11.8125 8.74999 11.8125C8.02512 11.8125 7.4375 12.4001 7.4375 13.125C7.4375 13.8499 8.02512 14.4375 8.74999 14.4375Z"
                                        fill={'black'}
                                    />
                                    <path
                                        d="M19.25 14.4375C19.9749 14.4375 20.5625 13.8499 20.5625 13.125C20.5625 12.4001 19.9749 11.8125 19.25 11.8125C18.5251 11.8125 17.9375 12.4001 17.9375 13.125C17.9375 13.8499 18.5251 14.4375 19.25 14.4375Z"
                                        fill={'black'}
                                    />
                                </svg>
                                <span>{t('ReportContents')}</span>
                            </button>
                        </Link>
                        {props.isAdmin && (
                            <Link to={`/events/${props.event.id}/modify`}>
                                <button className={styles.eventOptionItem}>
                                    <svg
                                        width="29"
                                        height="28"
                                        viewBox="0 0 29 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14 19.25C16.8995 19.25 19.25 16.8995 19.25 14C19.25 11.1005 16.8995 8.75 14 8.75C11.1005 8.75 8.75 11.1005 8.75 14C8.75 16.8995 11.1005 19.25 14 19.25Z"
                                            stroke={'black'}
                                        />
                                        <path
                                            d="M13.4391 4.82935L11.3752 3.28193C11.2645 3.19863 11.1356 3.14284 10.999 3.11915C10.8625 3.09546 10.7223 3.10456 10.59 3.14569C9.95078 3.34585 9.33064 3.60243 8.73688 3.91239C8.61397 3.97686 8.50815 4.06964 8.42816 4.18307C8.34817 4.2965 8.2963 4.42732 8.27683 4.56474L7.91199 7.11874C7.77292 7.24202 7.63677 7.37023 7.50354 7.50339C7.37035 7.63658 7.2421 7.77277 7.1188 7.91195L7.11874 7.91199L4.5652 8.27716C4.42799 8.29656 4.29736 8.34828 4.18408 8.42807C4.07079 8.50786 3.97808 8.61343 3.9136 8.73608C3.60316 9.3296 3.34608 9.94952 3.14541 10.5886C3.10408 10.7211 3.09486 10.8615 3.11851 10.9983C3.14215 11.135 3.19798 11.2642 3.28139 11.3751L4.82935 13.4391C4.81818 13.6246 4.81257 13.8115 4.81252 13.9999C4.81252 14.1882 4.81813 14.3752 4.82936 14.5608L4.82935 14.5609L3.28193 16.6247C3.19863 16.7355 3.14284 16.8644 3.11915 17.0009C3.09546 17.1375 3.10456 17.2777 3.14569 17.41C3.34585 18.0492 3.60243 18.6693 3.91239 19.2631C3.97686 19.386 4.06964 19.4918 4.18307 19.5718C4.2965 19.6518 4.42732 19.7037 4.56474 19.7231L7.11874 20.088C7.24201 20.227 7.37023 20.3632 7.50338 20.4964C7.63657 20.6296 7.77276 20.7579 7.91194 20.8812L7.91199 20.8812L8.27715 23.4348C8.29655 23.572 8.34828 23.7026 8.42807 23.8159C8.50786 23.9292 8.61343 24.0219 8.73608 24.0864C9.32959 24.3968 9.94952 24.6539 10.5885 24.8546C10.7211 24.8959 10.8615 24.9051 10.9982 24.8815C11.135 24.8578 11.2642 24.802 11.3751 24.7186L13.4391 23.1706C13.6246 23.1818 13.8115 23.1874 13.9999 23.1874C14.1882 23.1874 14.3752 23.1818 14.5608 23.1706L14.5609 23.1706L16.6247 24.718C16.7355 24.8013 16.8644 24.8571 17.0009 24.8808C17.1375 24.9045 17.2777 24.8954 17.41 24.8543C18.0492 24.6541 18.6693 24.3975 19.2631 24.0876C19.386 24.0231 19.4918 23.9303 19.5718 23.8169C19.6518 23.7035 19.7037 23.5726 19.7231 23.4352L20.088 20.8812C20.227 20.758 20.3632 20.6297 20.4964 20.4966C20.6296 20.3634 20.7579 20.2272 20.8812 20.088L20.8812 20.088L23.4348 19.7228C23.572 19.7034 23.7026 19.6517 23.8159 19.5719C23.9292 19.4921 24.0219 19.3865 24.0864 19.2639C24.3968 18.6704 24.6539 18.0504 24.8546 17.4114C24.8959 17.2789 24.9051 17.1385 24.8815 17.0017C24.8578 16.8649 24.802 16.7358 24.7186 16.6248L23.1706 14.5609C23.1818 14.3754 23.1874 14.1885 23.1874 14.0001C23.1874 13.8117 23.1818 13.6247 23.1706 13.4391L23.1706 13.4391L24.718 11.3752C24.8013 11.2645 24.8571 11.1356 24.8808 10.999C24.9045 10.8625 24.8954 10.7223 24.8543 10.59C24.6541 9.95078 24.3975 9.33064 24.0876 8.73688C24.0231 8.61397 23.9303 8.50815 23.8169 8.42816C23.7035 8.34817 23.5726 8.2963 23.4352 8.27683L20.8812 7.91199C20.758 7.77292 20.6297 7.63677 20.4966 7.50354C20.3634 7.37035 20.2272 7.2421 20.088 7.1188L20.088 7.11874L19.7228 4.5652C19.7034 4.42799 19.6517 4.29736 19.5719 4.18408C19.4921 4.07079 19.3865 3.97808 19.2639 3.9136C18.6704 3.60316 18.0504 3.34608 17.4114 3.14541C17.2789 3.10408 17.1385 3.09486 17.0017 3.11851C16.8649 3.14215 16.7358 3.19798 16.6248 3.28139L14.5609 4.82935C14.3754 4.81818 14.1885 4.81257 14.0001 4.81252C13.8117 4.81252 13.6247 4.81813 13.4391 4.82936L13.4391 4.82935Z"
                                            stroke={'black'}
                                        />
                                    </svg>
                                    <span>{t('ChangeEvent')}</span>
                                </button>
                            </Link>
                        )}
                        {props.isAdmin && (
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenModal(true);
                                }}>
                                <button className={styles.eventOptionItem}>
                                    <DeleteOutlineOutlinedIcon
                                        sx={{ color: 'red', width: 29, height: 28 }}
                                    />
                                    <span>{t('DeleteEvent')}</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {/* )} */}
            </Drawer>
            <Modal open={openModal}>
                <div className={isMobile ? stylesModal.modalMobile : stylesModal.modal}>
                    <Typography
                        marginTop={isMobile ? '3%' : '-1%'}
                        fontSize={'18px'}
                        textAlign={'center'}>
                        {t('DeleteVideoQuestion')}
                    </Typography>
                    <div className={stylesModal.flexContainer}>
                        {!loading ? (
                            <>
                                <Button
                                    className={
                                        isMobile
                                            ? stylesModal.confirmButtonMobile
                                            : stylesModal.confirmButton
                                    }
                                    onClick={() => {
                                        if (props.event.id) {
                                            deleteEvent(props.event.id);
                                        }
                                        setOpenModal(false);
                                    }}>
                                    {t('Yes')}
                                </Button>
                                <Button
                                    className={
                                        isMobile
                                            ? stylesModal.cancelButtonMobile
                                            : stylesModal.cancelButton
                                    }
                                    onClick={() => {
                                        setOpenModal(false);
                                        props.setIsClicked(false);
                                    }}>
                                    {t('Close')}
                                </Button>
                            </>
                        ) : (
                            <div
                                style={{
                                    margin: '0 auto'
                                }}>
                                <CircularProgress />
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
            {/* {isClicked && isMessage && (
                <div
                    onClick={() => props.setIsClicked(false)}
                    className={`${styles.wrapperOverlay} ${styles.unselectable}`}
                    style={{ backdropFilter: 'blur(4px)' }}>
                    <div className={styles.eventOptions}>
                        <Link to={`/report/${props.eventId}`}>
                            <button
                                className={styles.eventOptionItem}
                                style={{ background: 'white' }}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.3701 21.4247L14.7503 24.1244C14.6725 24.2539 14.5626 24.3612 14.4311 24.4356C14.2996 24.5101 14.1511 24.5492 14 24.5492C13.8489 24.5492 13.7003 24.5101 13.5688 24.4356C13.4374 24.3612 13.3274 24.2539 13.2497 24.1244L11.6299 21.4247C11.5521 21.2951 11.4422 21.1879 11.3107 21.1135C11.1792 21.039 11.0307 20.9999 10.8796 20.9999H4.375C4.14293 20.9999 3.92037 20.9077 3.75628 20.7436C3.59219 20.5795 3.5 20.357 3.5 20.1249V6.125C3.5 5.89293 3.59219 5.67037 3.75628 5.50628C3.92037 5.34219 4.14293 5.25 4.375 5.25H23.6249C23.857 5.25 24.0795 5.34219 24.2436 5.50628C24.4077 5.67037 24.4999 5.89293 24.4999 6.125V20.1249C24.4999 20.2399 24.4773 20.3536 24.4333 20.4598C24.3893 20.566 24.3249 20.6624 24.2436 20.7437C24.1624 20.8249 24.0659 20.8894 23.9598 20.9333C23.8536 20.9773 23.7398 20.9999 23.6249 20.9999L17.1204 20.9999C16.9693 20.9999 16.8207 21.039 16.6893 21.1135C16.5578 21.1879 16.4478 21.2951 16.3701 21.4247Z"
                                        stroke={'black'}
                                        strokeWidth="1.74999"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M14 14.4375C14.7249 14.4375 15.3125 13.8499 15.3125 13.125C15.3125 12.4001 14.7249 11.8125 14 11.8125C13.2751 11.8125 12.6875 12.4001 12.6875 13.125C12.6875 13.8499 13.2751 14.4375 14 14.4375Z"
                                        fill={'black'}
                                    />
                                    <path
                                        d="M8.74999 14.4375C9.47487 14.4375 10.0625 13.8499 10.0625 13.125C10.0625 12.4001 9.47487 11.8125 8.74999 11.8125C8.02512 11.8125 7.4375 12.4001 7.4375 13.125C7.4375 13.8499 8.02512 14.4375 8.74999 14.4375Z"
                                        fill={'black'}
                                    />
                                    <path
                                        d="M19.25 14.4375C19.9749 14.4375 20.5625 13.8499 20.5625 13.125C20.5625 12.4001 19.9749 11.8125 19.25 11.8125C18.5251 11.8125 17.9375 12.4001 17.9375 13.125C17.9375 13.8499 18.5251 14.4375 19.25 14.4375Z"
                                        fill={'black'}
                                    />
                                </svg>
                                <span>{t('ReportContents')}</span>
                            </button>
                        </Link>
                        {props.message.userId && (
                            <button
                                className={styles.eventOptionItem}
                                style={{ background: 'white' }}
                                onClick={() => props.setIsMessageBlocked(true)}>
                                <svg
                                    width="28"
                                    height="29"
                                    viewBox="0 0 28 29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14 24.6709C19.799 24.6709 24.5 19.9699 24.5 14.1709C24.5 8.37191 19.799 3.6709 14 3.6709C8.20101 3.6709 3.5 8.37191 3.5 14.1709C3.5 19.9699 8.20101 24.6709 14 24.6709Z"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeMiterlimit="10"
                                    />
                                    <path
                                        d="M6.57349 6.74432L21.4266 21.5974"
                                        stroke={'black'}
                                        strokeWidth="1.75"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span>{t('BlockUser')}</span>
                            </button>
                        )}
                    </div>
                </div>
            )} */}
        </>
    );
}

export default connect(mapStateToProps, null)(EventOptions);
